import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import c from './bottom-sheet.module.scss';

const BottomSheet = ({ isOpen, onClose, children }) => {
  const [isRendered, setIsRendered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 0);
    } else {
      setIsVisible(false);
      setTimeout(() => {
        setIsRendered(false);
      }, 300);
    }
  }, [isOpen]);

  if (!isRendered) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return createPortal(
    <div
      className={classNames(c.backdrop, { [c.isVisible]: isVisible })}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleBackdropClick(e);
        }
      }}
      onClick={handleBackdropClick}
    >
      <div className={c.bottomSheet}>
        <div className={c.content}>{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default BottomSheet;
